import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Transitions from "../../hoc/Transitions";
import NumberAuthentication from "./NumberAuthentication";
const ReportAuthentication = () => {
  const isAuth = useSelector((state) => state.Product.isAuth);
  const causes = JSON.parse(localStorage.getItem("selectedQue"));
  if (!isAuth && causes) {
    return (
      <>
        <Transitions>
          <NumberAuthentication />
        </Transitions>
      </>
    );
  } else {
    return <Redirect to="/" />;
  }
};

export default ReportAuthentication;
